import { getDayWordRu } from '@/utils/projectDeadlineRemaining';
import type { DeadlineTone, DeadlineView } from '../model/projectView';

/** Подсказка срока в строке списка: «Завершить запись до 29.10.2026» */
export function deadlineTooltipLabel(deadline: DeadlineView & { label: string }): string {
  return `${deadline.label} ${deadline.date}`;
}

/** Сколько осталось до дедлайна для строки списка: «5 дней», «−2 дня», «сегодня». */
export function deadlineLeftLabel(deadline: DeadlineView): string {
  const days = deadline.daysLeft;
  if (days === 0) return 'сегодня';
  return `${days < 0 ? '−' : ''}${Math.abs(days)} ${getDayWordRu(days)}`;
}

export const DEADLINE_TEXT_TONE: Record<DeadlineTone, string> = {
  urgent: 'nd:text-destructive',
  warning: 'nd:text-[color-mix(in_oklab,var(--warn)_75%,var(--foreground))]',
  calm: 'nd:text-muted-foreground',
  done: 'nd:text-muted-foreground',
};

/** Цвет бейджа срока в строке «в одну строку» — те же пороги, что у текста срока. */
export const DEADLINE_TONE_COLOR: Record<DeadlineTone, string> = {
  urgent: 'var(--destructive)',
  warning: 'var(--warn)',
  calm: 'var(--muted-foreground)',
  done: 'var(--muted-foreground)',
};
